import { render, staticRenderFns } from "./VerifyPassword.vue?vue&type=template&id=482bef5b&scoped=true"
import script from "./VerifyPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyPassword.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VerifyPassword.vue?vue&type=style&index=0&id=482bef5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482bef5b",
  null
  
)

export default component.exports